import { useContext } from 'react';
import { Redirect } from 'expo-router';

import { LoginMountContext } from '../contexts/LoginMount';
import { resolveLoginPath } from '../hooks/useLoginRouter';

/**
 * Wrapper for expo-router's <Redirect> that resolves login-relative paths
 * against the mount base. Use instead of <Redirect> anywhere in login's
 * source that redirects to a ROUTES.* target.
 */
export const LoginRedirect = ({ href }: { href: string }) => {
  const base = useContext(LoginMountContext);
  const resolved = resolveLoginPath(base, href);
  return <Redirect href={resolved as never} />;
};
